
document.addEventListener("DOMContentLoaded", function () {
  const link = document.getElementById("add_fabricsamples");

  if (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault(); // Prevents the default link behavior
      console.log("Add these fabricsamples" + variantMetafieldInfo[currentVariant].fabricsamples);
      add_fabricsamples_to_cart(variantMetafieldInfo[currentVariant].fabricsamples);
    });
  }
});

async function add_fabricsamples_to_cart(arr_vids) {
   let items = arr_vids.map((vid) => ({
    id: vid,
    quantity: 1,
    properties: {}
  }));
  
  if (items.length == 0) {
    return;
  }
  await addItems(items);

  const cartDrawer = window.document.querySelector('cart-drawer');
  //refresh the cart
  if (cartDrawer) {
      fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
        .then(response => response.text())
        .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newCartDrawer = html.querySelector('cart-drawer');

            if (newCartDrawer && cartDrawer) {
              cartDrawer.innerHTML = newCartDrawer.innerHTML;
              cartDrawer.classList.remove('is-empty');
              cartDrawer.open()
            }
        })
        .catch(error => console.error("Error refreshing cart:", error));
  }
}